import * as React from 'react';



export default class DownArrow extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-401.000000, -24.000000)">
            <g id="Group-27" transform="translate(401.000000, 24.000000)">
                <polygon id="Rectangle-18" points="5 8 11 8 8.21266345 11"></polygon>
            </g>
        </g>
      </svg>
    )
  }
}
